import React from 'react'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import AddressHeaderForm from '../address/AddressHeaderForm'
import { isGE } from '../Device'
import Page from '../genericComponents/Page'
import Header from '../header/Header'
import ItineraryButton from '../header/ItineraryButton'
import Main from '../main/Main'
import Map from '../map/Map'
import MenuCategoriesPE from '../menu/MenuCategoriesPE'
import ZfeCityMetaManager from './seo/ZfeCityMetaManager'
import ZfeCityMainContent from './ZfeCityMainContent'

export const renderPage = () => {
  const { LayerPage, withToaster, withMenuCategoriesPE } = PAGE_CLASSES

  return (
    <Page cssClasses={[LayerPage, withToaster, withMenuCategoriesPE]} key="Page">
      <ZfeCityMetaManager />
      <Map key="Map"></Map>
      <Header key="Header" headerButton={<ItineraryButton />} menuCategoriesPE={<MenuCategoriesPE />}>
        <AddressHeaderForm key="AddressHeaderForm" />
      </Header>
      <Main key="Main" withoutSubHeader={isGE()}>
        <ZfeCityMainContent />
      </Main>
    </Page>
  )
}
